import { SEO } from '../components/seo/SEO';
import BankTransferDetails from '../components/common/BankTransferDetails';
import { AboutHero } from '../components/about/AboutHero';
import { AboutStory } from '../components/about/AboutStory';
import { OrganizationDetails } from '../components/about/OrganizationDetails';
import { TeamMembers } from '../components/about/TeamMembers';
import { Achievements } from '../components/about/Achievements';
import { StatuteExcerpt } from '../components/about/StatuteExcerpt';
import { StatutoryGoals } from '../components/about/StatutoryGoals';
import { AboutContact } from '../components/about/AboutContact';
import { getBreadcrumbSchema, getOrganizationSchema } from '../lib/jsonLd';

export function AboutPage() {

  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Strona główna', url: 'https://znajdki.pl/' },
    { name: 'O nas', url: 'https://znajdki.pl/o-nas' }
  ]);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      breadcrumbSchema
    ]
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <SEO 
        title="O nas - Historia Fundacji Znajdki"
        description="Fundacja Znajdki ratuje i leczy bezdomne zwierzęta od 2012 roku. Poznaj naszą historię, misję, zespół i działalność. Pomagamy psom i kotom znaleźć nowy dom."
        url="/o-nas"
        image="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
        jsonLd={jsonLd}
      />

      <AboutHero />

      {/* W prostym języku */}
      <section className="mb-8">
        <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-6 rounded-lg shadow-lg">
          <h2 className="heading-4 no-margin">W skrócie</h2>
          <p className="body-medium no-margin mt-2">
            Ratujemy i leczymy zwierzęta, szukamy im domów, prowadzimy edukację. Działamy od 2012 roku dzięki wsparciu darczyńców i wolontariuszy.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <AboutStory />
          <div className="mt-8">
            <StatutoryGoals />
          </div>
        </div>
        <div className="space-y-8">
          <div>
            <OrganizationDetails />
            <div className="mt-8">
              <StatuteExcerpt />
            </div>
          </div>
          <div>
            <TeamMembers />
          </div>
          <div>
            <Achievements />
          </div>
        </div>
      </div>

      <AboutContact />

      {/* Bank Transfer Details */}
      <BankTransferDetails className="mt-16" />
    </div>
  );
}